module.exports = __webpack_public_path__ + "8b503b7190938d650e4a4323cdc1449d.png";